// Shared Google Maps JS loader config so every useJsApiLoader call matches
// (same id + libraries), avoiding "loader options changed" conflicts.
export const GOOGLE_MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY || "";
export const GOOGLE_MAPS_LIBRARIES = ["places"];
export const GOOGLE_MAPS_LOADER = {
  id: "google-map-script",
  googleMapsApiKey: GOOGLE_MAPS_KEY,
  libraries: GOOGLE_MAPS_LIBRARIES,
};
